import { mainApi } from "services/main";
import {
  ListDocumentsRequest,
  ListDocumentsResponse,
  GetDocumentByIdResponse,
  GetDocumentByIdRequest,
  DownloadUrlResponse,
  DownloadUrlRequest,
  UpdateDocumentsRequest,
  UpdateDocumentsResponse,
  DeleteDocumentsRequest,
  DeleteDocumentsResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    listDocuments: builder.query<ListDocumentsResponse, ListDocumentsRequest>({
      query: (request: ListDocumentsRequest) => ({
        url: "documents/" + encodeURIComponent(request.parentId),
      }),
      providesTags: ["Documents"],
      extraOptions: {
        delay: 2000,
      },
    }),
    getDocumentById: builder.query<
      GetDocumentByIdResponse,
      GetDocumentByIdRequest
    >({
      query: (request: GetDocumentByIdRequest) => ({
        url: "document/" + request.documentId,
      }),
    }),
    downloadUrl: builder.query<DownloadUrlResponse, DownloadUrlRequest>({
      query: (request: DownloadUrlRequest) => ({
        url: "documents/download-url/" + request.documentId,
        params: {
          preview: request.preview,
        },
      }),
    }),
    updateDocuments: builder.mutation<
      UpdateDocumentsResponse,
      UpdateDocumentsRequest
    >({
      query: (request: UpdateDocumentsRequest) => ({
        url: "documents",
        body: request,
        method: "PUT",
      }),
      invalidatesTags: ["Documents"],
    }),
    updateDocumentsForMove: builder.mutation<
      UpdateDocumentsResponse,
      UpdateDocumentsRequest
    >({
      query: (request: UpdateDocumentsRequest) => ({
        url: "documents",
        body: request,
        method: "PUT",
      }),
    }),
    deleteDocuments: builder.mutation<
      DeleteDocumentsResponse,
      DeleteDocumentsRequest
    >({
      query: (request: DeleteDocumentsRequest) => ({
        url: "documents/delete",
        body: request,
        method: "POST",
      }),
      invalidatesTags: ["Documents"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListDocumentsQuery,
  useGetDocumentByIdQuery,
  useDownloadUrlQuery,
  useLazyDownloadUrlQuery,
  useUpdateDocumentsMutation,
  useUpdateDocumentsForMoveMutation,
  useDeleteDocumentsMutation,
} = extendedApi;
